/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Status_ReviewInputs */

const en_manual_qc_status_review = /** @type {(inputs: Manual_Qc_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review`)
};

const fr_manual_qc_status_review = /** @type {(inputs: Manual_Qc_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revue`)
};

const de_manual_qc_status_review = /** @type {(inputs: Manual_Qc_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezension`)
};

const it_manual_qc_status_review = /** @type {(inputs: Manual_Qc_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisione`)
};

const ru_manual_qc_status_review = /** @type {(inputs: Manual_Qc_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор`)
};

const es_manual_qc_status_review = /** @type {(inputs: Manual_Qc_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar`)
};

const zh_cn2_manual_qc_status_review = /** @type {(inputs: Manual_Qc_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审查`)
};

const ja_manual_qc_status_review = /** @type {(inputs: Manual_Qc_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レビュー`)
};

const hi_manual_qc_status_review = /** @type {(inputs: Manual_Qc_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समीक्षा`)
};

const pt_pt2_manual_qc_status_review = /** @type {(inputs: Manual_Qc_Status_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise`)
};

/**
* | output |
* | --- |
* | "Review" |
*
* @param {Manual_Qc_Status_ReviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_status_review = /** @type {((inputs?: Manual_Qc_Status_ReviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Status_ReviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_status_review(inputs)
	if (locale === "de") return de_manual_qc_status_review(inputs)
	if (locale === "it") return it_manual_qc_status_review(inputs)
	if (locale === "ru") return ru_manual_qc_status_review(inputs)
	if (locale === "es") return es_manual_qc_status_review(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_status_review(inputs)
	if (locale === "ja") return ja_manual_qc_status_review(inputs)
	if (locale === "hi") return hi_manual_qc_status_review(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_status_review(inputs)
	return en_manual_qc_status_review(inputs)
});